import type { RouteObject } from "react-router-dom";
import { AddLeadPage } from "./AddLead";
import { BookTrialPage } from "./BookTrial";
import { LeadProfile } from "./LeadProfile";
import { LeadsPage } from "./LeadsPage";

/** The pipeline. Static paths sit beside `:id`; the router ranks them first. */
export const routes: RouteObject[] = [
  { path: "leads", element: <LeadsPage /> },
  { path: "leads/new", element: <AddLeadPage /> },
  { path: "leads/trial", element: <BookTrialPage /> },
  { path: "leads/:id", element: <LeadProfile /> },
];
